import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import { getUserInfo, validateUser } from './actions';
import { GET_USER_INFO, VALIDATE_USER } from './constants';

const userInfoSelector = (state) => {
  return state.user;
};

export const useUser = {
  state: () => {
    return useSelect(userInfoSelector);
  },
  actions: () => {
    return {
      getUserInfo: useAction(getUserInfo, {
        async: useAsync(GET_USER_INFO),
      }),
      validateUser: useAction(validateUser, {
        saga: useAsync(VALIDATE_USER),
      }),
    };
  },
};
